var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.625 1H5.375V1.625H4.75V2.875H4.125V2.25H2.875V2.875H2.25V4.125H2.875V4.75H1.625V5.375H1V6.625H1.625V7.25H2.875V7.875H2.25V9.125H2.875V9.75H4.125V9.125H4.75V10.375H5.375V11H6.625V10.375H7.25V9.125H7.875V9.75H9.125V9.125H9.75V7.875H9.125V7.25H10.375V6.625H11V5.375H10.375V4.75H9.125V4.125H9.75V2.875H9.125V2.25H7.875V2.875H7.25V1.625H6.625V1ZM6.625 1.625V2.875H7.25V3.5H7.875V2.875H9.125V4.125H8.5V4.75H9.125V5.375H10.375V6.625H9.125V7.25H8.5V7.875H9.125V9.125H7.875V8.5H7.25V9.125H6.625V10.375H5.375V9.125H4.75V8.5H4.125V9.125H2.875V7.875H3.5V7.25H2.875V6.625H1.625V5.375H2.875V4.75H3.5V4.125H2.875V2.875H4.125V3.5H4.75V2.875H5.375V1.625H6.625ZM5.375 4.125H6.625V4.75H5.375V4.125ZM4.75 5.375V4.75H5.375V5.375H4.75ZM4.75 6.625H4.125V5.375H4.75V6.625ZM5.375 7.25H4.75V6.625H5.375V7.25ZM6.625 7.25V7.875H5.375V7.25H6.625ZM7.25 6.625V7.25H6.625V6.625H7.25ZM7.25 5.375H7.875V6.625H7.25V5.375ZM7.25 5.375V4.75H6.625V5.375H7.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsS);
export default __webpack_public_path__ + "static/media/settings-s.139d0cd9e2f73a2439919a63949402d3.svg";
export { ForwardRef as ReactComponent };